import { useEmailTemplatesContext } from "@/components/modules/email-templates-sidebar/context";
import { useSelectorIsFollowUpEmail } from "@/components/modules/email-templates-sidebar/selectors";
import { DeleteFollowupEmailButton } from "./delete-button";
import { FollowupScheduler } from "./scheduler";
import { Divider } from "@/modules/email-templates-sidebar/shared/divider";

export const PreviewSettingsSection = () => {
  const { drafts, activeTemplateId, activeEmailSequenceItemId } =
    useEmailTemplatesContext();

  const isFollowUpEmail = useSelectorIsFollowUpEmail(
    drafts,
    activeTemplateId,
    activeEmailSequenceItemId
  );

  return isFollowUpEmail ? (
    <section>
      <Divider className="mb-4" />
      <FollowupScheduler className="mb-4" />
      <Divider className="my-4 mb-6" />
      <DeleteFollowupEmailButton />
    </section>
  ) : null;
};
